/** Presentation feedback reacts once to real edits, never to a restored board. */
export class GameFeedback {
  constructor({ audio, confetti }) {
    this.audio = audio;
    this.confetti = confetti;
    this.revision = null;
  }
  render(state, reset = false) {
    this.audio.setEnabled(state.prefs.soundEffects);
    if (reset) {
      this.confetti.stop();
      this.audio.board();
    }
    if (state.revision === this.revision) return;
    this.revision = state.revision;
    if (reset || !state.effect.changed) return;
    if (state.effect.markIndices?.length) this.audio.scratch();
    if (state.effect.errorIndex !== undefined) this.audio.mistake();
    if (state.effect.won) {
      this.audio.finish();
      this.confetti.start();
    } else if (state.effect.placementIndex !== undefined) this.audio.cat();
  }
  unlock() { this.audio.unlock(); }
  setHostPaused(paused) {
    this.audio.setHostPaused(paused);
    if (paused) this.confetti.stop();
  }
  suspend() {
    this.audio.suspend();
    this.confetti.stop();
  }
  refreshMotion() { this.confetti.refreshMotion(); }
  inFrontOf(dialog) { this.confetti.inFrontOf(dialog); }
  stopCelebration() { this.confetti.stop(); }
  destroy() {
    this.audio.destroy();
    this.confetti.destroy();
  }
}
